var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.49,11.77c.05-.05,.08-.12,.08-.2v-1.6c0-.08-.03-.14-.08-.2-.05-.05-.12-.08-.19-.08h-1.6c-.07,0-.14,.03-.19,.08-.05,.05-.08,.12-.08,.2v1.6c0,.08,.03,.14,.08,.2,.05,.05,.12,.08,.19,.08h1.6c.07,0,.14-.03,.19-.08Zm-.03-3.21c.05-.04,.08-.08,.09-.14l.15-3.86c0-.07-.03-.12-.08-.16-.07-.06-.14-.09-.2-.09h-1.84c-.06,0-.13,.03-.2,.09-.06,.04-.08,.1-.08,.18l.14,3.84c0,.06,.03,.1,.08,.14,.06,.04,.12,.05,.2,.05h1.55c.08,0,.14-.02,.2-.05ZM8.04,.15c.17,.1,.3,.24,.39,.41l6.41,11.85c.19,.35,.19,.71-.02,1.06-.09,.16-.22,.29-.39,.39-.16,.1-.34,.14-.53,.14H1.09c-.19,0-.37-.05-.53-.14-.16-.1-.29-.22-.39-.39-.21-.35-.21-.71-.02-1.06L6.56,.56c.09-.17,.23-.31,.39-.41,.17-.1,.35-.15,.54-.15s.38,.05,.54,.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.de31568ce672274f4e3bc2db064c16f8.svg";
export { ForwardRef as ReactComponent };